import { ModelMail } from "@/type/core/models/models.types";
import BasicButton from "@components/core/buttons/BasicButton";
import BasicLink from "@components/core/links/BasicLink";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ROUTES } from "@routes/Routes";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import DuplicateIcon from "@static/core/icons/icon-duplicate.svg?react";
import EditIcon from "@static/core/icons/icon-edit.svg?react";
import { ColumnsType } from "antd/lib/table/interface";
import i18n from "i18next";
import { Dispatch, SetStateAction } from "react";

export const columns = (
  setIsDeleteModelOpen: Dispatch<SetStateAction<boolean>>,
  setIsDuplicateModelOpen: Dispatch<SetStateAction<boolean>>,
  setSelectedModelMail: Dispatch<SetStateAction<ModelMail | undefined>>,
  onSetDefault: (modelMailId: string) => void,
): ColumnsType<ModelMail> => [
  {
    title: i18n.t("offices.mailModel.headers.name"),
    dataIndex: "name",
    sorter: (a, b) => a.name?.localeCompare(b.name ?? "") ?? 1,
    showSorterTooltip: false,
    defaultSortOrder: "ascend",
  },
  {
    title: i18n.t("offices.mailModel.headers.type"),
    dataIndex: "type",
    render: (type: string) => {
      return type === "invitation" ? (
        <>{i18n.t("offices.mailModel.type.invitation")}</>
      ) : (
        <>{i18n.t("offices.mailModel.type.endOfTransaction")}</>
      );
    },
  },
  {
    title: i18n.t("offices.mailModel.headers.defaultModel"),
    dataIndex: "defaultModel",
    render: (defaultModel: boolean, { id }) => {
      return defaultModel ? (
        <>
          {i18n.t("offices.mailModel.defaultModel.default")}
          <FontAwesomeIcon icon={faCheckCircle} className="text-primary ml-8" />
        </>
      ) : (
        <BasicButton
          variant="transparent"
          text={i18n.t("offices.mailModel.defaultModel.makeDefault")}
          className="p-0"
          onClick={() => {
            if (id) {
              onSetDefault(id);
            }
          }}
        />
      );
    },
  },
  {
    dataIndex: "id",
    width: 162,
    render: (id: string, modelMail: ModelMail) => {
      return (
        <div className="d-flex align-items-center justify-content-center gap-24">
          <BasicLink
            to={ROUTES.extranet.menu.offices.mailModel.details.generate(
              id,
              modelMail.type,
            )}
          >
            <EditIcon className="picto icon-30" />
          </BasicLink>
          <DeleteIcon
            className="picto icon-30"
            onClick={() => {
              setSelectedModelMail(modelMail);
              setIsDeleteModelOpen(true);
            }}
          />
          <DuplicateIcon
            className="picto icon-30"
            onClick={() => {
              setSelectedModelMail(modelMail);
              setIsDuplicateModelOpen(true);
            }}
          />
        </div>
      );
    },
  },
];
